import { useEffect, MutableRefObject } from 'react';
import type { MapRef } from 'react-map-gl';
import { requestedMapBoundsQuery } from '../../../../core/networkMap/queries';
import { useAppSelector } from '../../../../types';
import { FIT_BOUNDS_OPTIONS } from '../map-configuration';

const useZoomControl = (mapRef: MutableRefObject<MapRef | null>) => {
    const requestedBounds = useAppSelector(requestedMapBoundsQuery);

    useEffect(() => {
        if (requestedBounds) {
            mapRef.current?.fitBounds(requestedBounds, FIT_BOUNDS_OPTIONS);
        }
    }, [requestedBounds]);
};

export default useZoomControl;
